export default __webpack_public_path__ + "static/SUSS_logo-9ed655989ed8c1f93db67824d4bdfb46.jpg";